import React from 'react';
import './index.scss';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

const LIST_TAB = {
  'financialAnalysis.tabs.fc': 1,
  'financialAnalysis.tabs.fr': 2,
  'financialAnalysis.tabs.zmf': 3,
};

class SwitchTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listTab: [
        { value: `financialAnalysis.tabs.fc` },
        { value: `financialAnalysis.tabs.zmf` },
      ],
    };
  }

  onclickTab = value => {
    const { handleSwitchTab } = this.props;

    handleSwitchTab(LIST_TAB[value]);
  };

  render() {
    const { listTab } = this.state;
    const { currentTab } = this.props;

    return (
      <div className="fa-switch-tab-wrapper  my-first-step">
        {listTab.map(({ value }) => {
          return (
            <div
              key={value}
              className={`level-item mr-3`}
              onClick={() => this.onclickTab(value)}
            >
              <div
                className={`${
                  currentTab === LIST_TAB[value]
                    ? 'level-item__title'
                    : 'level-item__title level-item__title--grey'
                }`}
              >
                {I18n.t(value)}
              </div>
              <div
                className={`${
                  currentTab === LIST_TAB[value]
                    ? 'level-item__underline level-item__underline--selected'
                    : 'level-item__underline'
                }`}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(SwitchTab);
